export var replaceBrWithNewLine = function (text) { return text.replace(/<br\s*\/?>/gi, '\n'); };
export var replaceNewLineWithBr = function (text) { return text.replace(/\n/g, '<br/>'); };
